import * as Sentry from '@sentry/react';
import { isBlank } from './helpers/commonHelper';

if (
  !isBlank(process.env.REACT_APP_SENTRY_API_KEY) &&
  !isBlank(process.env.REACT_APP_SENTRY_PROJECT) &&
  !isBlank(process.env.REACT_APP_SENTRY_ENV)
) {
  Sentry.init({
    dsn: `https://${process.env.REACT_APP_SENTRY_API_KEY}@sentry.io/${process.env.REACT_APP_SENTRY_PROJECT}`,
    environment: `${process.env.REACT_APP_SENTRY_ENV}`,
    release: `${process.env.REACT_APP_RELEASE_VERSION}`,
    integrations: [
      // eslint-disable-next-line no-restricted-globals
      Sentry.reactRouterV5BrowserTracingIntegration({ history }),
      Sentry.captureConsoleIntegration({
        levels: ['warn', 'error'],
      }),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^\//, `${process.env.REACT_APP_API_BASE_URL}`],
    ignoreErrors: ["Can't find variable: ProductPageDetector"],
  });
}
